// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__32Kux","error":"Textarea_error__1_1rC","readonly":"Textarea_readonly__2HVtG","disabled":"Textarea_disabled__16hz7"};